// import React, { useEffect } from 'react';

// const AddExtendedWarranty = () => {
  
  
//   return (
//     <div>AddExtendedWarranty</div>
//   );
// }

// export default AddExtendedWarranty;


import React, { useEffect, useState } from "react";
// // import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
// import backicon from "../../../../../Assets/icons/backIcon.svg"
// import backicon from './../../../../../../Assets/icons/backIcon.svg';
import backicon from "../../../../../Assets/icons/backIcon.svg"
// // import "./index.scss";
import { useNavigate } from "react-router-dom";
// // import ROUTES_NAVIGATION from "../../../../../../routes/routes";
// import axiosInstance from "../../../../services/api/API";
// import Swal from "sweetalert2";
// import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
// import Loader from "../../../../customComponents/CustomLoader";
import AddIssueDynemicForm from "../../addIssueDynemicFrom";
// import axiosInstance from "../../../../../services/api/API";
// import { toastError, toastSuccess } from "../../../../../customComponents/customToast/Toast";
// import { ToastContainer } from "react-toastify";
// import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
// import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Swal from "sweetalert2";
// import Loader from "../../../../../customComponents/CustomLoader";
import axiosInstance from "../../../../services/api/API";
import Loader from "../../../../customComponents/CustomLoader";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";


const AddExtendedWarranty = () => {
  const [formData, setFormData] = useState({});
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [ userTypedd, setUserTypedd ] = useState([])

  const [ poListDd, setPoListDd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")

  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/jobcard/po-list",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.po_id,
        label:user.po_number,
      }))
      setPoListDd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  useEffect(()  => {
    setFormData({
      status:1
    })
  },[])
  const DepartmentInputs = [
    {
      name: "poId",
      label: "Select Purchase Order",
      placeholder:"Enter Department Name",
      type: "dropdown",
      required: true,
      options:poListDd,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "warrantyDay",
      label: "Warranty Duration (days)",
      placeholder:"Enter Warranty Duration ",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        maxLength:3,
       },
    },
    {
      name: "status",
      label: "Active",
      type: "toggle",
      required: true,
      options: [{ label: "Active", value: 1 }, { label: "Inactive", value: 0 }],
      gridClass: "col-lg-4",
    },
    // {
    //   name: "status",
    //   label: "Status Name",
    //   type: "dropdown",
    //   required: true,
    //   options: [
    //     { id: 1, label: "Active", value: "Active" },
    //     { id: 0, label: "Inactive", value: "Inactive" },
    //   ],
    //   gridClass: "col-lg-4",
    //   validation: { required: true },
    // },
  ];
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate form fields
    DepartmentInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.required &&
          field.validation &&
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
  
    // If validation fails, set errors and return
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
   
  
    // Show confirmation alert before creating department
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to create this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
  
    // If the user cancels
    if (!result.isConfirmed) {
     // setLoading(false); // Stop loading state
      Swal.fire({
        title: "Cancelled",
        text: "Warranty creation has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
      return; // Exit the function if the user cancels
    }
  
    try {
      setLoading(true);
      const payload = {
        poId: formData.poId,
        warrantyDay: formData.warrantyDay.toString(),
        // status: formData.status === "Active" ? 1 : 0,
      };
  
      // Handle business partner ID based on user type
    //   if (userType === "superadmin") {
    //     payload.business_partner_id = formData.business_partner_id;
    //   } else {
    //     payload.business_partner_id = businessPartnerId;
    //   }
  
      // API request to create the department
      const response = await axiosInstance.post("/jobcard/request-create-extended-warranty", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      // Success handling
      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Record added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/manage-services/extended-warranty");
        });
      }
  
      console.log("Department added successfully:", response.data);
    } catch (error) {
      console.error("Error adding department:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); // Stop loading state
    }
  };
  
  
  
  
  return (
    <>
     {loading ? (
          <Loader />
        ) : (
          <>
      <div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Extended Warranty Request</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
        Please enter extended warranty details
        </span>
        <DynamicForm
          formConfig={DepartmentInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => {
            if (!isFormSubmitted) {
              handleFormSubmit(formData); // Call handleFormSubmit if isFormSubmitted is false
            }
          }}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
        )}
    </>
  );
};

export default AddExtendedWarranty;
